import React from "react";
import Script from "next/script";
import { CHATBOT_ALLOW_ATTR } from "./chatbotGuardSnippet";

type KenytProps = { botId?: string | null; googleAdsConversionId?: string | null };

const Kenyt = ({ botId, googleAdsConversionId: adsConvProp }: KenytProps = {}) => {
  const kenytBotId = (botId && botId.trim()) || process.env.NEXT_PUBLIC_KENYT_BOT_ID;
  const googleAdsConversionId =
    (adsConvProp && adsConvProp.trim()) ||
    process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_ID;

  if (!kenytBotId) {
    // Only rendered when the CMS selected Kenyt, so a missing bot id is a broken deploy.
    if (typeof window !== "undefined") {
      console.warn(
        "[Kenyt] chatbot_provider is 'kenyt' but NEXT_PUBLIC_KENYT_BOT_ID is missing from this build — no widget will load."
      );
    }
    return null;
  }

  return (
    <>
      <link rel="preconnect" href="https://www.kenyt.ai" />
      <Script
        src="https://www.kenyt.ai/botapp/ChatbotUI/dist/js/bot-loader.js"
        type="text/javascript"
        data-bot={kenytBotId}
        // This injection is provider-gated, so opt it out of the ChatbotGuard block.
        {...{ [CHATBOT_ALLOW_ATTR]: "" }}
        id="kenyt-bot-loader"
        strategy="lazyOnload"
      />
      <Script
        id="kenyt-onload"
        type="text/javascript"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
                window.addEventListener('load', function() {
                  document.addEventListener('kenytEvent', function(event) {
                      if (event.detail.eventType === "kenyt_UserMessage") {
                          gtag('event', 'conversion', {
                              'send_to': '${googleAdsConversionId || ""}'
                          });
                      } else if (event.detail.eventType === "kenyt_ContactFormSubmit") {
                          gtag('event', 'conversion', {
                              'send_to': '${googleAdsConversionId || ""}'
                          });
                      }
                  });
                });
              `,
        }}
      />
    </>
  );
};

export default Kenyt;
